const SmallArrow = () => (
  <svg width="72" height="6" viewBox="0 0 72 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M72 3L67 0.113249V5.88675L72 3ZM0 3.5H67.5V2.5H0V3.5Z" fill="#6C6596" />
  </svg>
)

export default SmallArrow
